<template>
	<v-tooltip top>
    <template v-slot:activator="activator">
			<v-menu
				v-model="menu"
				:close-on-content-click="false"
				offset-y
				v-bind="menuProps"
				v-on="activator.on"
			>
				<template v-slot:activator="{ on }">
					<v-btn
						:disabled="disabled"
						v-bind="inputProps"
						v-on="on"
						@click="resetPicker"
					>
						{{inputValue}}
					</v-btn>
				</template>
				<v-stepper
					id="range-steper"
					non-linear
					v-model="stepperIndex"
					class="vessi-stepper"
					v-if="$vuetify.breakpoint.mdAndDown"
				>
					<v-flex>
							<v-menu offset-y>
								<template v-slot:activator="{ on }">
									<v-btn
										color="primary"
										outlined
										text
										block
										v-on="on"
									>
										Predeterminados
										<v-icon right>expand_more</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item
										v-for="(preset, index) in presets"
										:key="index"
										@click="selectPreset(preset)"
									>
										<v-list-item-title>{{ preset.label }}</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
						 </v-flex>
					<v-stepper-header>
						<template>
							<v-stepper-step
								editable
								:step="1"
							>
								Inicio
							</v-stepper-step>
							<v-divider/>
							<v-stepper-step
								editable
								:step="2"
							>
								Fin
							</v-stepper-step>
						</template>
					</v-stepper-header>
					
					<v-stepper-items>
						<v-stepper-content :step="1">
							<div
								:data-days="highlightDates.length"
								:class="{
									'v-date-range__pickers': true,
									'v-date-range--highlighted': highlightDates.length
								}"
							>
								<v-date-picker
									class="v-date-range__picker--start v-date-range__picker"
									v-model="pickerStart"
									light
									:locale="locale"
									:min="min"
									:max="pickerEnd || max"
									:no-title="noTitle"
									:next-icon="nextIcon"
									:prev-icon="prevIcon"
									:events="highlightDates"
									:event-color="highlightClasses"
									v-on:input="changePickerTo(2)"
								></v-date-picker>
							</div>
						</v-stepper-content>
						<v-stepper-content :step="2">
							<div
								:data-days="highlightDates.length"
								:class="{
									'v-date-range__pickers': true,
									'v-date-range--highlighted': highlightDates.length
								}"
							>
								<v-date-picker
									class="v-date-range__picker--end v-date-range__picker"
									v-model="pickerEnd"
									:locale="locale"
									:min="pickerStart || min"
									:max="max"
									:no-title="noTitle"
									:next-icon="nextIcon"
									:prev-icon="prevIcon"
									:events="highlightDates"
									:event-color="highlightClasses"
								></v-date-picker>
							</div>
						</v-stepper-content>
					</v-stepper-items>
					<v-layout grid-list-md text-xs-center>
							<v-btn block tile color="success" sm @click="applyRange()">
								Confirmar
							</v-btn>
					</v-layout>
				</v-stepper>
				<v-card v-else>
					<v-card-text>
					<v-row>
						<v-menu offset-y>
							<template v-slot:activator="{ on }">
								<v-btn
									color="primary"
									outlined
									text
									block
									v-on="on"
								>
									Predeterminados
									<v-icon right>expand_more</v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item
									v-for="(preset, index) in presets"
									:key="index"
									@click="selectPreset(preset)"
								>
									<v-list-item-title>{{ preset.label }}</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
						<v-col justify="center" align="center">
							<h2>Desde</h2>
							<v-date-picker
								elevation="1"
								class="v-date-range__picker--start v-date-range__picker"
								v-model="pickerStart"
								light
								:full-width="true"
								:locale="locale"
								:min="min"
								:max="pickerEnd || max"
								:no-title="noTitle"
								:next-icon="nextIcon"
								:prev-icon="prevIcon"
								:events="highlightDates"
								:event-color="highlightClasses"
								v-on:input="changePickerTo(2)"
							></v-date-picker>
						</v-col>
						<v-col justify="center" align="center">
							<h2>Hasta</h2>
							<v-date-picker
								elevation="1"
								class="v-date-range__picker--end v-date-range__picker"
								:full-width="true"
								v-model="pickerEnd"
								:locale="locale"
								:min="pickerStart || min"
								:max="max"
								:no-title="noTitle"
								:next-icon="nextIcon"
								:prev-icon="prevIcon"
								:events="highlightDates"
								:event-color="highlightClasses"
							></v-date-picker>
						</v-col>
					</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn block tile color="success" sm @click="applyRange()">
							Confirmar
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-menu>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>
<script>

import { format, parseISO, differenceInCalendarDays, addDays, subDays } from 'date-fns';
import { VMenu, VList } from 'vuetify/lib';
const isoFormat = 'yyyy-MM-dd';
const defaultDate = format(new Date(), isoFormat);

export default {
	name: 'v-daterange',
	components:{
		VMenu,
		VList
	},
	props: {
		input:{
			type: Object,
			default:()=>{
				return {}
			}
		},
		// Take start and end as the input. Passable via v-model.
		value: {
			type: Object,
			default: () => {
				return { from: defaultDate, to: defaultDate };
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		presets: {
			type: Array,
			default: () => {
				return [
					/*{
						label: vm.$t('date.intervals.today'),
						range: [
							format(new Date(), 'YYYY-MM-dd'),
							format(new Date(), 'YYYY-MM-dd')
						]
					},*/
					{
						label: 'Ayer',
						range: [
							format(subDays(new Date(), 1), 'yyyy-MM-dd'),
							format(subDays(new Date(), 1), 'yyyy-MM-dd')
						]
					},
					{
						label: 'Última Semana',
						range: [
							format(subDays(new Date(), 7), 'yyyy-MM-dd'),
							format(subDays(new Date(), 0), 'yyyy-MM-dd')
						]
					},
					{
						label: 'Este Mes',
						range: [
							new Date().GetCurrentMonthRange().from,
							format(subDays(new Date(), 0), 'yyyy-MM-dd')
						]
					},
					{
						label: '6 Meses',
						range: [
							new Date().GetLast6Month().from,
							format(subDays(new Date(), 1), 'yyyy-MM-dd')
						]
					},
					{
						label: 'Último Año',
						range: [
							new Date().GetLastYear().from,
							format(subDays(new Date(), 0), 'yyyy-MM-dd')
						]
					}
				];
			}
		},
		noPresets: {
			type: Boolean,
			default: false
		},
		// Denotes the Placeholder string for start date.
		startLabel: {
			type: String,
			default: 'Start Date'
		},
		// Denotes the Placeholder string for start date.
		endLabel: {
			type: String,
			default: 'End Date'
		},
		// The string that gets placed between `startLabel` and `endLabel`
		separatorLabel: {
			type: String,
			default: 'To'
		},
		presetLabel: {
			type: String,
			default: 'Presets'
		},
		/**
		 * Following values are all passable to vuetify's own datepicker
		 * component.
		 */
		// Min selectable date.
		min: {
			type: String,
			default: undefined
		},
		// Max selectable date
		max: {
			type: String,
			default: undefined
		},
		// Locale
		locale: {
			type: String,
			default: 'en-us'
		},
		noTitle: {
			type: Boolean,
			default: false
		},
		displayFormat: {
			type: String
		},
		highlightColor: {
			type: String,
			default: 'blue lighten-5'
		},
		/**
		 * Icons
		 */
		nextIcon: {
			type: String,
			default: '$vuetify.icons.next'
		},
		prevIcon: {
			type: String,
			default: '$vuetify.icons.prev'
		},
		inputProps: {
			type: Object,
			default: () => {
				return {};
			}
		},
		menuProps: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
			menu: false,
			pickerStart: this.value.from,
			pickerEnd: this.value.to,
			highlightDates: [],
			highlightClasses: {},
			stepperIndex: 0,
			selectedPreset: {},
		};
	},
	computed: {
		inputValue() {
			if (this.isValueEmpty) {
				return '';
			}
			const from = this.displayFormat
				? this.formatDate(this.value.from, this.displayFormat)
				: this.value.from;
			const to = this.displayFormat
				? this.formatDate(this.value.to, this.displayFormat)
				: this.value.to;
			return `${from} ${this.separatorLabel} ${to}`;
		},
		placeholder() {
			return `${this.startLabel}    ${this.separatorLabel}    ${this.endLabel}`;
		},
		/**
		 * If the value prop doesn't have any start value,
		 * its most likely that an empty object was passed.
		 */
		isValueEmpty() {
			return !this.value.from;
		},
		/**
		 * If the user has selected both the dates or not
		 */
		bothSelected() {
			return this.pickerStart && this.pickerEnd;
		},
		isPresetActive() {
			return this.presets.map(
				preset =>
					preset.range[0] === this.pickerStart &&
					preset.range[1] === this.pickerEnd
			);
		},
		tooltip(){
			return this.hasOwnProperty('$t') ? this.$t('dashboard.fechasTooltip'):'';
		}
	},
	methods: {
		resetPicker: function(evt){
			this.stepperIndex = 1;
		},
		changePickerTo( index ){
			this.stepperIndex = index;
		},
		/**
		 * Emit the input event with the updated range data.
		 * This makes v-model work.
		 */
		applyRange() {
			this.$emit('input', {
				from: this.pickerStart,
				to: this.pickerEnd
			});
			this.menu = false;
		},
		/**
		 * Called every time the menu is closed.
		 * It also emits an event to tell the parent
		 * that the menu has closed.
		 *
		 * Upon closing the datepicker values are set
		 * to the current selected value.
		 */
		closeMenu() {
			// Reset the changed values for datepicker models.
			this.pickerStart = this.value.from;
			this.pickerEnd = this.value.to;
			this.highlight();
			this.$emit('menu-closed');
		},
		formatDate(date, fmt) {
			return format(parseISO(date), fmt);
		},
		highlight() {
			if (!this.bothSelected) {
				return;
			}
			const dates = [];
			const classes = {};
			const start = parseISO(this.pickerStart);
			const end = parseISO(this.pickerEnd);
			const diff = Math.abs(differenceInCalendarDays(start, end));

			// Loop though all the days in range.
			for (let i = 0; i <= diff; i++) {
				const date = format(addDays(start, i), isoFormat);
				dates.push(date);
				const classesArr = [];
				classesArr.push(`v-date-range__in-range`);
				classesArr.push(this.highlightColor);
				i === 0 && classesArr.push(`v-date-range__range-start`);
				i === diff && classesArr.push(`v-date-range__range-end`);
				classes[date] = classesArr.join(' ');
			}
			this.highlightDates = dates;
			this.highlightClasses = classes;
		},
		selectPreset( preset ) {
			this.pickerStart = preset.range[0];
			this.pickerEnd = preset.range[1];
		}
	},
	watch: {
		// Watching to see if the menu is closed.
		menu(isOpen) {
			if (!isOpen) {
				this.closeMenu();
			} else {
				this.highlight();
			}
		},
		pickerStart: 'highlight',
		pickerEnd: 'highlight'
	}
};

Date.prototype.yyyymmdd = function() {
	var mm = this.getMonth() + 1; // getMonth() is zero-based
	var dd = this.getDate();

	return [this.getFullYear(),
					(mm>9 ? '' : '0') + mm,
					(dd>9 ? '' : '0') + dd
				 ].join('-');
};

Date.prototype.GetCurrentMonthRange = function() {
	var date = new Date();
	var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

	return {
		from: firstDay.yyyymmdd(),
		to: lastDay.yyyymmdd()
	}
};

Date.prototype.GetLast6Month = function(){
	var from = new Date((new Date()).setMonth( ( new Date().getMonth()-6 ) ));
	var to = new Date();
	return { from:from.yyyymmdd(), to:to.yyyymmdd() }
};

Date.prototype.GetLastYear = function(){
	var from = new Date(new Date().setFullYear( new Date().getFullYear()-1 ))
	var to = new Date();
	return { from:from.yyyymmdd(), to:to.yyyymmdd() }
};

Date.prototype.GetPresetRange = function( presetRange ){
	
	switch (presetRange) {
		case 'thisMonth':
			return this.GetCurrentMonthRange();
		break;
		case '6MonthsAgo':
			return this.GetLast6Month();
		break;
		case 'thisYear':
			return this.GetLastYear()
		break;
		default:
			return this.GetCurrentMonthRange();
	}
};

import moment from 'moment';

Date.prototype.getCurrentDate = function(){
	
	return moment.utc(new Date()).local().format('DD/MM/YYYY HH:mm:ss');
}

Date.prototype.getCurrentLocalDate = function(){
	
	return moment.utc( this.toUTCString() ).local().format('DD/MM/YYYY HH:mm:ss');
}

Date.prototype.parseUTCToLocal = function(str){
	return moment.utc( str ).local().format('DD/MM/YYYY HH:mm:ss');
}

Date.prototype.getDateTag= function(){
	return this.getCurrentLocalDate().replace(/\/|T|:|\s/g, '' );
}



</script>
<style type="text/css">

	.vessi-stepper .v-stepper__content{
		padding: 0;
	}
	
	.vessi-stepper .v-picker--date, .vessi-stepper .v-picker__body{
		width:100% !important;
	}
	
	.v-date-picker-table{
		height: auto !important;
	}
	.v-date-range__input-field input {
		text-align: center;
	}
	
	.v-date-range__content {
		display: flex;
	}
	
	.v-date-range__content .v-date-picker-table {
		border-radius: 0;
	}
	
	.v-date-range__content {
		display: flex;
	}
	
	.v-date-range__content .v-date-picker-table .v-btn {
		border-radius: 0;
	}

	.v-date-range__pickers .v-date-picker-table__events {
		height: 100%;
		width: 100%;
		top: 0;
		z-index: -1;
	}
	
	.v-date-range__pickers .v-date-picker-table__events {
		height: 100%;
		width: 100%;
		top: 0;
		z-index: -1;
	}
	
	.v-date-range__pickers .v-date-picker-table table,
	.v-date-range__pickers .v-date-picker-table table th,
	.v-date-range__pickers .v-date-picker-table table td {
		width: auto;
		margin: auto;
		border-collapse: collapse;
	}
	
	.v-date-range__pickers .v-date-picker-table table td .v-btn .v-btn--outlined,
	.v-date-range__pickers .v-date-picker-table table td .v-btn .v-btn--active::before
	{

		border: none;
		box-shadow: 0 0 0 1px black inset;
		background-color: transparent !important;
	}

</style>

/*.v-date-range__pickers >>> .v-date-picker-table table {*/
/*	width: auto;*/
/*	margin: auto;*/
/*	border-collapse: collapse;*/

/*	& th, & td {*/
/*		height: 32px;*/
/*		width: 32px;*/
/*	}*/

/*	& td {*/
/*		.v-btn {*/
/*			&.v-btn--outlined {*/
/*				border: none;*/
/*				box-shadow: 0 0 0 1px currentColor inset;*/
/*			}*/

/*			&.v-btn--active::before {*/
/*				background-color: transparent !important;*/
/*			}*/
/*		}*/
/*	}*/
/*}*/

/* =====  End of Date buttons  ====== */
/* =============================================
=            Highlighting the even bubble dot            =
============================================= */
<!--.v-date-range__pickers >>> .v-date-range__in-range {-->
<!--	height: 100%;-->
<!--	width: 100%;-->
<!--	margin: 0;-->
<!--	border-radius: 0;-->
<!--}-->

/* =====  End of Highlighting the even bubble dot  ====== */
